import { clsx } from "clsx";
import { twMerge } from "tailwind-merge";

export function cn(...inputs) {
  return twMerge(clsx(inputs));
}

export function formatDate(d, opts = {}) {
  if (!d) return "";
  const date = typeof d === "string" ? new Date(d) : d;
  return date.toLocaleDateString(undefined, {
    month: "short",
    day: "numeric",
    year: opts.year ? "numeric" : undefined,
  });
}

export function formatTime(d) {
  if (!d) return "";
  const date = typeof d === "string" ? new Date(d) : d;
  return date.toLocaleTimeString([], { hour: "numeric", minute: "2-digit" });
}

export function formatDateTime(d) {
  if (!d) return "";
  return `${formatDate(d)} · ${formatTime(d)}`;
}

export function timeAgo(d) {
  if (!d) return "";
  const date = typeof d === "string" ? new Date(d) : d;
  const diff = (Date.now() - date.getTime()) / 1000;
  if (diff < 60) return `${Math.max(1, Math.floor(diff))}s ago`;
  if (diff < 3600) return `${Math.floor(diff / 60)}m ago`;
  if (diff < 86400) return `${Math.floor(diff / 3600)}h ago`;
  if (diff < 2592000) return `${Math.floor(diff / 86400)}d ago`;
  return formatDate(d);
}

export function classBySeverity(level) {
  const map = {
    info: "text-[color:var(--accent-cyan)]",
    warning: "text-[color:var(--accent-amber)]",
    success: "text-[color:var(--accent-green)]",
    danger: "text-[color:var(--accent-red)]",
  };
  return map[level] || map.info;
}

export function truncate(str, n = 120) {
  if (!str) return "";
  return str.length > n ? `${str.slice(0, n).trim()}…` : str;
}
